import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

interface WalletBTCAddressStore {
  walletBTCAddresses: { [key: string]: string }
  setWalletBTCAddress: (walletId: string, address: string) => void
}

export const createWalletBTCAddressesStore = (storage: StateStorage) =>
  createStore<WalletBTCAddressStore>(
    storage,
    (set, get) => ({
      walletBTCAddresses: {},
      setWalletBTCAddress: (walletId, address) => {
        const btcAddresses = get().walletBTCAddresses
        set({
          walletBTCAddresses: { ...btcAddresses, [walletId]: address },
        })
      },
    }),
    {
      persist: {
        name: 'walletBTCAddresses',
        version: 0,
      },
    }
  )
